import { render, staticRenderFns } from "./ChangeRoute.vue?vue&type=template&id=e05ee654&"
import script from "./ChangeRoute.vue?vue&type=script&lang=js&"
export * from "./ChangeRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports